import React from "react";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import List from "app/pages/.shared/List";
import Separator from "app/pages/.shared/Separator";
import IconWarning from "app/pages/.shared/static/icons/IconWarning";

const InsuranceContentNoInsurance = () => (
	<div className="insurances__free">
		<Separator />

		<header className="insurances__no-header">
			<FormattedMessage id="payment.no.insurance.header.label" />
		</header>

		<section className="insurances__details">
			<div className="insurances__details-list">
				<List
					items={[
						<div key="itemWithout2" className="insurances__details-list__item">
							<FormattedMessage
								id="payment.insurance.none.text.3"
								tagName="span"
								values={{
									amount: <AmountContainer amount={20000} />,
								}}
							/>
							<IconWarning />
						</div>,
					]}
				/>
			</div>
		</section>
	</div>
);

export default InsuranceContentNoInsurance;
